<template>
    <q-layout
            view="lhh LpR lff"
            container
            class="window-height"
            :class="$q.dark.isActive ? 'bg-grey-9' : 'bg-grey-3'"
    >
        <q-header class="bg-primary">
            <q-toolbar>
                <q-toolbar-title>Отчет эффективности менеджеров</q-toolbar-title>
                <q-btn flat @click="drawerRight = !drawerRight" round dense icon="menu"/>
            </q-toolbar>
        </q-header>


        <q-drawer
                side="right"
                v-model="drawerRight"
                bordered
                :width="308"
                :breakpoint="500"
        >
            <q-scroll-area class="fit">
                <div class="q-pa-sm" style="padding-bottom: 40px">
                    <q-date v-model="filters.date.value" range mask="YYYY-MM-DD" class="q-mb-sm"/>

                    <q-btn-toggle
                        v-model="reportType"
                        toggle-color="primary"
                        class="q-mb-lg full-width"
                        :options="[
                          {label: 'Накопительный', value: 'cumulative'},
                          {label: 'Основной', value: 'main'},
                        ]"
                    />

                    <q-select
                        v-if="data.filters"
                        class="q-mb-sm"
                        filled
                        v-model="filters.category_id.value"
                        :options="objectToOptions(data.filters.category_id)"
                        multiple
                        counter
                        use-chips
                        stack-label
                        label="Категория"
                        use-input
                    />

                    <div class="memo">
                      Чекбокс имеет 3 состояния - влючен (да), выключен (нет) и неизвестен (-)
                    </div>
                </div>
                <div class="q-pa-sm fixed-bottom bg-white">
                    <q-btn class="full-width" :loading="isLoading" :disabled="isLoading" color="primary"
                           @click="saveSettings" label="Построить отчет"/>
                </div>
            </q-scroll-area>
        </q-drawer>

        <q-page-container>
            <q-page v-if="data.records && data.columns">
                <div>
                    <q-table
                            :rows="data.records"
                            :columns="data.columns"
                            row-key="name"
                            :pagination="{rowsPerPage: 0}"
                            class="sticky-header-column-table"
                    >
                      <template v-slot:body-cell-revenue="props">
                        <q-td :props="props">
                          {{ format(props.row.revenue) }}
                        </q-td>
                      </template>

                      <template v-slot:body-cell="props">
                        <q-td :props="props">
                          <template v-if="props.row[props.col.ids] && props.row[props.col.ids].length !== 0">
                            <Popper arrow>
                              <button class="popperButton">{{ props.row[props.col.name] }}</button>
                              <template #content>
                                <div class="scroll">
                                  <div v-for="(value, key) in props.row[props.col.ids]" :key="key">
                                    <a :href="value" target="_blank">{{ key }}</a>
                                  </div>
                                </div>
                              </template>
                            </Popper>
                          </template>
                          <template v-else>
                            {{ props.row[props.col.name] }}
                          </template>
                        </q-td>
                      </template>

                      <template v-slot:bottom-row>
                        <q-tr align="center" class="totals-row">
                          <q-td v-for="(col, index) in data.columns" :key="index">

                            <div v-if="col.countable">
                              {{calculateColumnTotal(col.name)}}
                            </div>

                          </q-td>
                        </q-tr>
                      </template>

                    </q-table>
                </div>

            </q-page>
            <q-page v-else style="padding-top: 30px" class="q-pa-md">
                <q-banner inline-actions class="text-white bg-red">
                    Выберите даты и постройте отчет.
                </q-banner>

            </q-page>

        </q-page-container>
    </q-layout>

</template>

<script setup>

import {onMounted, reactive, ref} from "vue"
import {ajax, ajaxDownload, objectToOptions} from "@/assets/js/functions"
import Popper from "vue3-popper"
import '@/assets/css/style.css'


const isLoading = ref(true)
const drawerRight = ref(true)
const settings = ref({})
const data = ref({})

const reportType = ref('cumulative')
const totals = reactive({})

const filters = reactive({
    date: {
        value: new Date().toISOString().split('T')[0],
        operator: 'BETWEEN_DATES',
        column: 'begin_date'
    },
    category_id: {
      value: null,
      column: 'category_id',
      operator: 'IN'
    },
    opened: {
      value: null,
      column: 'opened',
      operator: '='
    },
    closed: {
      value: null,
      column: 'closed',
      operator: '='
    },

})

onMounted(async () => {
    saveSettings()
})

const format = (value) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

const isNumericColumn = (field) => {
  return typeof data.value.records[0][field] === 'number';
}

const calculateColumnTotal = (field) => {
  let total = 0;

  switch (field)
  {
    case 'lead_meet':
      total = calculatePercent(totals['ads_client'], totals['deals_count'])
      break;
    case 'meet_reserve':
      total = calculatePercent(totals['reserve_count'], totals['visit_count'])
      break;
    case 'reserve_deal':
      total = calculatePercent(totals['sales_count'], totals['reserve_count'])
      break;
    case 'lead_deal':
      total = calculatePercent(totals['sales_count'], totals['deals_count'])
      break;
    case 'cycle_lead_meet':
    case 'cycle_lead_sale':
      let count = 0;
      total = data.value.records.reduce((total, row) => {
        if (isNumericColumn(field) && row[field] !== null && row[field] !== undefined) {
          count++;
          return total + row[field];
        }
        return total;
      }, 0);

      total = count > 0 ? total / count : 0
      break;
    default:
      total = data.value.records.reduce((total, row) => {
        return total + (isNumericColumn(field) ? row[field] : 0);
      }, 0);
  }

  totals[field] = total


  return total.toLocaleString()
}
const calculatePercent = (number1, number2) =>
{
  if (number2 === 0 || number2 === undefined)
    return 0

  return (number1 / number2 * 100).toFixed(2)
}

const saveSettings = () => {
    isLoading.value = true

    ajax({
        action: "getROIReport",
        params: filters,
        reportType: reportType.value
    }, (response) => {
        data.value = response
        isLoading.value = false
        console.log(response)
    })
}


</script>